import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CountriesInfoSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="rounded" width="100%" height={32} />
    {Array.from({ length: 5 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width="100%" height={48} />
    ))}
  </Styles.Container>
)

export default CountriesInfoSkeleton
